import axios, { AxiosInstance, AxiosError } from 'axios';
import { DEFAULT_API_CONFIG } from '../config/api';

// Create axios instance
const apiClient: AxiosInstance = axios.create(DEFAULT_API_CONFIG);

// Log API configuration for debugging
console.log('🌐 API Client initialized with baseURL:', DEFAULT_API_CONFIG.baseURL);

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('🔑 Adding auth token to request:', config.url);
  } else {
    console.warn('⚠️ No auth token found in localStorage');
  }
  return config;
});

// Handle token refresh on 401 errors
apiClient.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.config.url, response.status);
    return response;
  },
  async (error: AxiosError) => {
    console.error('❌ API Error:', error.config?.url, error.response?.status, error.response?.data);
    
    if (error.response?.status === 401 && !(error.config as any)?._retry) {
      (error.config as any)._retry = true;
      console.log('🔄 Attempting token refresh...');
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          const response = await axios.post(`${DEFAULT_API_CONFIG.baseURL}/refresh-token`, {
            refreshToken
          });
          if (response.data.success) {
            const { token, refreshToken: newRefreshToken } = response.data.data;
            localStorage.setItem('accessToken', token);
            localStorage.setItem('refreshToken', newRefreshToken);
            if (error.config) {
              error.config.headers.Authorization = `Bearer ${token}`;
              return apiClient(error.config);
            }
          }
        }
      } catch (refreshError) {
        console.error('❌ Token refresh failed, redirecting to login');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;

